import React from "react";
import { AdvancedRealTimeChart } from "react-ts-tradingview-widgets";

const StockChart = (props) => {
  return (
    <div style={{ width: "100%", height: "100%" }}>
      <AdvancedRealTimeChart
        symbol={props.symbol}
        allow_symbol_change={false}
        hide_top_toolbar={true}
        range={"3M"}
        interval="D"
        style={{ theme: "light" }}
        enable_publishing={false}
        hide_legend={true}
        studies={[
          {
            id: "MASimple@tv-basicstudies",
            version: 60,
            inputs: {
              length: 50,
            },
          },
          {
            id: "MASimple@tv-basicstudies",
            version: 60,
            inputs: {
              length: 100,
            },
          },
          {
            id: "MASimple@tv-basicstudies",
            version: 60,
            inputs: {
              length: 200,
            },
          },
        ]}
        studies_overrides={[{ "moving average.length": 50 }]}
        width="100%"
        height="100%"
        hide_side_toolbar={true}
        locale="en"
        container_id="tradingview_chart"
      />
    </div>
  );
};

export default StockChart;
